import React, { useState } from "react";
import { AppBar, Container } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import AdbIcon from "@mui/icons-material/Adb";
// import logo from "../../../assets/images/blacklogo.png";
import logo from "../../../assets/images/techifyblack.svg";
import notification from "../../../assets/images/notification.png";
// import useriocn from "../../../assets/images/useriocn.png";
import { Link, useLocation } from "react-router-dom";
import LinkData from "./Lisks.json";
import NotificationsSlide from "../../admin/auth/NotificationsSlide";
import UserInfoPopup from "../../admin/auth/UserInfoPopup";
import {
  LogoImage,
  Toolbarstyles,
  SignUpButton,
  DeskTopLink,
  LogoMain,
  AuthButtonMain,
  ToolbarMain,
  NotificationBTn,
} from "./AdminStyles";
import { useSelector } from "react-redux";
// import { ConstructionOutlined } from "@mui/icons-material";

const IsProfilePages = [
  "/profile-change-password",
  "/profile-pay-methods",
  "/profile-edit-card",
];
const IsCustomerPages = ["/admin/customer-details", "/admin/customers"];
const IsDriversPages = ["/admin/drivers", "/admin/drivers/personal-details"];
const IsDispatchesPages = ["/admin/dispatches", "/admin/dispatche-details"];

const AdminHeader = () => {
  const location = useLocation();
  const [showDrawer, setshowDrawer] = useState(false);
  const [isAuth, setisAuth] = useState(false);
  const { user: userInfo = {} } = useSelector((state) => state?.auth);
  const userAbilities = userInfo?.abilities || [];
  const isAdmin = userInfo?.role === "admin";
  const allowedLinks = LinkData.homeLink.filter(
    (value) => isAdmin || userAbilities.includes(value.title)
  );

  // const navigate = useNavigate();
  // const [anchorElNav, setAnchorElNav] = useState(null);
  // const [anchorElUser, setAnchorElUser] = useState(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  // };
  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  return (
    <>
      <AppBar
        position="static"
        sx={{ padding: "5px 0", boxShadow: "none", background: "#E1E1E1" }}
      >
        <Container maxWidth="lg">
          <ToolbarMain sx={Toolbarstyles.root}>
            <LogoMain>
              <Link to="/">
                <LogoImage src={logo} alt="logoimg" />
              </Link>
            </LogoMain>
            {/* <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {LinkData.homeLink.map((value, index) => (
                  <MenuItem key={index + "1242"} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{value.title}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box> */}

            <DeskTopLink sx={{ display: { xs: "none", md: "flex" } }}>
              {allowedLinks.map((value) => {
                const isActiveLink =
                  location.pathname === value.url ||
                  (IsProfilePages.includes(location.pathname) &&
                    value.title === "Profile") ||
                  (IsCustomerPages.includes(location.pathname) &&
                    value.title === "Customers") ||
                  (IsDriversPages.includes(location.pathname) &&
                    value.title === "Drivers") ||
                  (IsDispatchesPages.includes(location.pathname) &&
                    value.title === "Dispatches") ||
                  (location.pathname.startsWith("/admin/dispatche-details") &&
                    value.title === "Dispatches") ||
                  (location.pathname.startsWith("/admin/customer-details") &&
                    value.title === "Customers") ||
                  (location.pathname.startsWith(
                    "/admin/drivers/personal-details"
                  ) &&
                    value.title === "Drivers");

                return (
                  <>
                    <Link
                      to={value.url}
                      key={value.url + "_" + value.title}
                      className={isActiveLink ? "active_link" : ""}
                    >
                      {value.title}
                    </Link>
                  </>
                );
              })}
            </DeskTopLink>

            <AuthButtonMain>
              {!isAuth ? (
                <>
                  {/* this is for the Notification */}
                  <NotificationBTn
                    variant="contained"
                    color="primary"
                    startIcon={<img src={notification} alt="notification" />}
                    disableRipple
                    onClick={() => setshowDrawer(!showDrawer)}
                  />
                  {/* user btn */}
                  {/* <NotificationBTn
                    variant="contained"
                    color="primary"
                    startIcon={<img src={useriocn} alt="useriocn" />}
                    disableRipple
                  /> */}
                  <UserInfoPopup />
                </>
              ) : (
                <SignUpButton
                  variant="contained"
                  // onClick={() => navigate("/signup")}
                >
                  Sign out
                </SignUpButton>
              )}
            </AuthButtonMain>
          </ToolbarMain>
        </Container>
      </AppBar>
      <NotificationsSlide
        showDrawer={showDrawer}
        setshowDrawer={setshowDrawer}
      />
    </>
  );
};

export default AdminHeader;
